import React, { useState } from "react";
import { Card, Tab, Nav } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useLocation } from "react-router-dom";
import ReuploadProfileCard from "./ReuploadProfileCard";

export default function ReUploadProfile() {
  const location = useLocation();

  return (
    <div>
      <PageTitle
        activeMenu="Face Verification Requested"
        motherMenu="Face Verification"
      />
      <Card>
        <Card.Body>
          <div className="default-tab">
            <ReuploadProfileCard />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
